export enum FileCategory {
    LicenseCert = "LICENSE/CERT",
    Insurance = "INSURANCE",
    Id = "ID",
}